import { ShieldCheck, Receipt, Timer, BadgeCheck, MapPin, CreditCard } from "lucide-react";
import { GUARANTEES } from "../lib/data";
import Reveal from "./Reveal";

const ICONS = { ShieldCheck, Receipt, Timer, BadgeCheck, MapPin, CreditCard };

export default function Guarantees() {
  return (
    <section id="garanties" data-testid="guarantees-section" className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="text-center max-w-2xl mx-auto mb-14">
          <Reveal>
            <span className="overline">Nos garanties</span>
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="mt-3 font-display font-extrabold text-ink text-3xl md:text-5xl leading-tight">
              Pourquoi nous faire <span className="gradient-text">confiance</span>
            </h2>
          </Reveal>
          <Reveal delay={0.2}>
            <p className="mt-4 text-lg text-ink-soft">
              Un dépannage sérieux repose sur des engagements clairs. Voici les nôtres, appliqués à
              chaque intervention.
            </p>
          </Reveal>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {GUARANTEES.map((g, i) => {
            const Icon = ICONS[g.icon];
            return (
              <Reveal key={g.title} delay={(i % 3) * 0.1}>
                <div className="card-soft h-full p-7 hover:translate-y-[-6px]">
                  <span className="h-12 w-12 rounded-2xl bg-brand/10 flex items-center justify-center">
                    <Icon className="h-6 w-6 text-brand" />
                  </span>
                  <h3 className="font-display font-bold text-ink text-xl mt-5">{g.title}</h3>
                  <p className="text-ink-soft mt-2 leading-relaxed">{g.text}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
